var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHunterXterLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 21,
    r: 20.5,
    transform: "rotate(180 20.5 21)",
    fill: "#4C1506",
    fillOpacity: 0.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5156 25.5532C16.5428 26.537 17.839 27.7731 19.3553 27.0668C19.8934 26.8145 20.2847 26.1334 20.4804 25.5279L26.5701 25.5279C28.062 25.5279 29.2848 24.2666 29.2848 22.7278L29.2848 18.4897C29.2848 16.9509 28.062 15.6896 26.5701 15.6896L20.5293 15.6896C20.2113 14.5292 19.0863 13.6715 17.9368 14.0247C16.6895 14.4031 15.809 15.286 14.8552 16.1437C14.1704 16.7743 13.1188 17.9348 12.5563 19.0952C11.3579 21.5926 13.9015 23.9891 15.5156 25.5532Z",
    fill: "#FFB6A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunterXterLeft);
export default __webpack_public_path__ + "static/media/hunter-xter-left.780e11f4012c20cbebaaa4b1fdc0b610.svg";
export { ForwardRef as ReactComponent };